import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { BsFillTrashFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';

import dateFormat from 'dateformat';

import { BootstrapTable } from '@components/Table/Table';
import { cancellationCartApi } from '@reducers/order/order';

const renderActionCell = ({ row }) => {
  const { login } = useSelector((state) => state.auth.user);
  const { id } = row.values;
  const { isDedicatedChannel } = row.original;
  const [trigger, { isLoading }] = isDedicatedChannel
    ? cancellationCartApi.useDeleteChannelOrderFromCartMutation()
    : cancellationCartApi.useRemoveDidFromCartMutation();
  return (
    <Button
      variant="didxl"
      onClick={() => {
        trigger({ id, login });
      }}
      disabled={isLoading}
    >
      <BsFillTrashFill size={17} />
    </Button>
  );
};

export const CancellationsCheckoutTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        id: 'id',
        Header: '',
        accessor: 'id',
      },
      {
        Header: 'Number',
        accessor: 'did',
        className: 'col-md-2',
      },
      {
        Header: 'Country',
        accessor: 'country',
        className: 'col-md-2',
      },

      { Header: 'Area', accessor: 'area', className: 'col-md-1' },
      {
        Header: 'TOS',
        accessor: 'type_of_service',
        className: 'col-md-2',
      },
      {
        Header: 'Cancellation Date',
        accessor: 'cancellation_date',
        className: 'col-md-1',
        Cell: ({ value }) => {
          const date = new Date(value);
          return dateFormat(date, 'defaultDate');
        },
      },
      {
        Header: 'Action',
        accessor: 'action',
        className: 'col-md-1',
        Cell: renderActionCell,
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        className: 'normalFontSize',
      })}
      hiddenColumns="id"
    />
  );
};
